import { jsx as jsx$1, jsxs as jsxs$1 } from '@emotion/react/jsx-runtime';
import { p as parseProps } from '../../dist/parseProps-780b287c.browser.esm.js';
export { Fragment } from 'react';
import '@theme-ui/css';

const jsx = (type, props, key) => jsx$1(type, parseProps(props), key);
const jsxs = (type, props, key) => jsxs$1(type, parseProps(props), key);

export { jsx, jsxs };
